var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMagicianHat = function SvgMagicianHat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    vectorEffect: "non-scaling-stroke",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M23.25.75 9 11.25m-2.25-9h3M8.25.75v3M1.5 8.25H6M3.75 6v4.5m14.902 12.75a62 62 0 0 1-.561-5.97m-12.182 0a63 63 0 0 1-.561 5.97"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M17.25 9.519c3.568.755 6 2.254 6 3.981 0 2.485-5.037 4.5-11.25 4.5S.75 15.985.75 13.5a1.9 1.9 0 0 1 .156-.75"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12.75 12.009c3.375.083 6 .719 6 1.491 0 .828-3.022 1.5-6.75 1.5s-6.75-.672-6.75-1.5"
  })));
};
export default SvgMagicianHat;